import { Clock } from 'lucide-react'
import { Carte, Message } from '../composants/base'

/** Une fonction prévue mais non construite : l'interface le dit franchement. */
export default function APlusTard({
  titre,
  phase,
  explication,
  manque,
}: {
  titre: string
  phase: string
  explication: string
  manque: string[]
}) {
  return (
    <div className="mx-auto max-w-2xl pt-6">
      <Carte>
        <div className="px-6 py-6">
          <div className="mb-3 flex items-center gap-2">
            <Clock className="h-5 w-5 text-bleu-400" />
            <h1 className="text-[18px] font-semibold">{titre}</h1>
            <span className="pastille bg-bleu-50 text-bleu-700">{phase}</span>
          </div>
          <p className="mb-4 text-[14px] leading-relaxed text-ardoise">{explication}</p>
          <Message ton="info">
            <p className="font-medium">Ce qu’il manque pour s’y mettre :</p>
            <ul className="mt-1 list-disc pl-4">
              {manque.map((m) => (
                <li key={m}>{m}</li>
              ))}
            </ul>
          </Message>
        </div>
      </Carte>
    </div>
  )
}
